import { render } from "./BlockquoteBlock.vue?vue&type=template&id=2ed1cb08&scoped=true"
import script from "./BlockquoteBlock.vue?vue&type=script&lang=js"
export * from "./BlockquoteBlock.vue?vue&type=script&lang=js"

import "./BlockquoteBlock.vue?vue&type=style&index=0&id=2ed1cb08&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed1cb08"]])

export default __exports__